import React from "react";

import { ConfigType, WidgetDrawerProps } from "../../../types/widgets";
import { DiscountMessageBoxVariantSettings } from "../DiscountMessageBoxWidgetsTab/DiscountMessageBoxVariantSettings";
import { DiscountProgressBarVariantSettings } from "../DiscountProgressBarWidgetsTab/DiscountProgressBarVariantSettings";
import { DiscountQuantityWidgetVariantSettings } from "../DiscountQuantityWidgetsTab/DiscountQuantityWidgetVariantSettings";
import { ShippingProgressBarVariantSettings } from "../ShippingProgressBarWidgetsTab/ShippingProgressBarVariantSettings";

type VariantSettingsProps = WidgetDrawerProps & { configType: ConfigType };
export const VariantSettings = ({
  widgetType,
  configType,
}: VariantSettingsProps) => {
  if (widgetType === "quantityButtons") {
    return <DiscountQuantityWidgetVariantSettings configType={configType} />;
  }
  if (widgetType === "discountProgressBar") {
    return <DiscountProgressBarVariantSettings configType={configType} />;
  }

  if (widgetType === "shippingProgressBar") {
    return <ShippingProgressBarVariantSettings configType={configType} />;
  }

  if (widgetType === "messageBoxPopup" || widgetType === "messageBoxSlideOut") {
    return (
      <DiscountMessageBoxVariantSettings
        widgetType={widgetType}
        configType={configType}
      />
    );
  }

  return null;
};
